import { render, staticRenderFns } from "./EditSubcategory.vue?vue&type=template&id=babf9618"
import script from "./EditSubcategory.vue?vue&type=script&lang=js"
export * from "./EditSubcategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports